export var parsedToken = function (parToken) {
    return parToken.auth_token;
};
export var getAccountCodeFromToken = function (parToken) {
    var _a, _b, _c, _d, _e, _f;
    return (((_a = parToken === null || parToken === void 0 ? void 0 : parToken.Ai) === null || _a === void 0 ? void 0 : _a.trim()) ||
        ((_b = parToken === null || parToken === void 0 ? void 0 : parToken.CAi) === null || _b === void 0 ? void 0 : _b.trim()) ||
        ((_d = (_c = parToken === null || parToken === void 0 ? void 0 : parToken.user) === null || _c === void 0 ? void 0 : _c.CAi) === null || _d === void 0 ? void 0 : _d.trim()) ||
        ((_f = (_e = parToken === null || parToken === void 0 ? void 0 : parToken.user) === null || _e === void 0 ? void 0 : _e.Ai) === null || _f === void 0 ? void 0 : _f.trim()));
};
export var getLgSrc = function (parToken) {
    return parToken.lgnSrc ? parToken.lgnSrc : parToken.src;
};
export var getIsImpersonatedFromToken = function (parToken) {
    return parToken.isImpersonated;
};
export var salesGetEmployeeCode = function (parToken) {
    return parToken.employeeCode;
};
export var getaccTypeFromToken = function (parToken) {
    return parToken.accType;
};
//iFrame is used in sales-journey
export var getIsInIFrame = function () {
    var inIframe = false;
    try {
        inIframe = window.self !== window.top;
    }
    catch (e) {
        //for catch cross origin
        inIframe = true;
    }
    return inIframe;
};
export var getEmailFromToken = function (parToken) { var _a; return (_a = parToken.email) !== null && _a !== void 0 ? _a : ""; };
